import { createAsyncThunk } from '@reduxjs/toolkit';
import { Vector3Tuple } from 'three';

import type { RootState } from '@/stores/store';

import { getCameraSettingsForBBox } from '../../utils/camera';
import { selectOffsetRootBbox } from '../bboxes/bboxes.selectors';

import { selectCameraViewport } from './camera.selectors';
import type { CameraSliceState } from './camera.slice';

export const resetCameraToTarget = createAsyncThunk<void, void>(
  'camera/reset',
  async (_, api) => {
    const state = api.getState() as RootState;
    const desc = selectOffsetRootBbox(state);

    // using the offsetted bbox and center
    api.dispatch(
      setCameraToBbox({
        bbox: desc || null,
      }),
    );
  },
);

export const setCameraToBbox = createAsyncThunk<
  Partial<CameraSliceState> | null,
  { bbox: { center: Vector3Tuple; radius: number } | null }
>('camera/setToBBox', async ({ bbox }, api) => {
  const state = api.getState() as RootState;
  const viewport = selectCameraViewport(state);

  if (!bbox) {
    return null;
  }

  const { zoom } = getCameraSettingsForBBox(viewport, bbox);

  return {
    zoom,
    target: bbox.center,
  };
});
